const FIXED_CACHE_KEY_SHARE_BET = "generateCouponShareLinkKey";
export {
  FIXED_CACHE_KEY_SHARE_BET
};
